var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pui-datatable',{attrs:{"modelName":_vm.modelName,"actions":_vm.actions,"modelColumnDefs":_vm.columnDefs}}),(!_vm.isLdapActive)?_c('pui-user-reset-password-dialog',{attrs:{"modelName":_vm.modelName}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }